import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Service, Terminal, Ticket } from '../../shared/models';
import { isPrevisionHiddenForProvider } from '../../shared/utils/prevision-visibility';

export interface ResumeTicketItem {
  ticket: Ticket;
  service: Service;
  serviceName: string;
  queueName?: string;
  customerName?: string;
  queueAccessKey?: string;
  canContinue: boolean;
}

@Component({
  selector: 'app-resume-ticket-page',
  templateUrl: './resume-ticket-page.component.html',
  styleUrls: ['./resume-ticket-page.component.scss']
})
export class ResumeTicketPageComponent {
  @Input() locationName: string;
  @Input() terminal: Terminal;
  @Input() tickets: ResumeTicketItem[] = [];
  @Output() continueTicket = new EventEmitter<ResumeTicketItem>();
  @Output() createNewTicket = new EventEmitter<void>();

  // Empresa configurada para nao exibir a previsao de atendimento.
  isPrevisionHidden(item: ResumeTicketItem): boolean {
    return isPrevisionHiddenForProvider(item.ticket && item.ticket.providerId);
  }

  openTicket(item: ResumeTicketItem): void {
    if (item.canContinue) {
      this.continueTicket.emit(item);
    }
  }
}
